import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import { LinearChartItem } from 'features/dashboard/ts/LinearCharItem';
import theme from 'styles/themes/app';
import { CustomTooltip } from './CustomTooltip';
import { YAxisTick } from './YAxisTick';
import i18n from 'locales/i18n';

interface RechartsLinearChartProps {
  data: LinearChartItem[];
  interval: number;
  tickFormatter?: (value: number, index: number) => string;
  tooltipFormatter?: (date: Date) => string;
  color: string;
}

export const RechartsLinearChart: React.FC<RechartsLinearChartProps> = ({
  data,
  interval,
  tickFormatter,
  color,
  tooltipFormatter,
}) => {
  const direction = i18n.dir()
  return (
    <ResponsiveContainer width="100%" height={320}>
      <AreaChart
        width={660}
        height={265}
        data={data}
        margin={{
          top: 15,
          right: 18,
          bottom: 15,
          left: 15,
        }}
      >
        <CartesianGrid stroke={theme.palette.grey[700]} vertical={false} />
        <XAxis
          tickLine={false}
          tickMargin={theme.spacing(13)}
          axisLine={false}
          dataKey="date"
          interval={interval}
          tickFormatter={tickFormatter}
          reversed={direction === "rtl"}
        />
        <YAxis
          tick={payload => <YAxisTick {...payload} />}
          tickLine={false}
          tickMargin={theme.spacing(13)}
          axisLine={false}
          orientation={direction === "rtl" ? "right" : "left"}
        />
        <Area type="linear" dataKey="total" stroke={color} fill={color} fillOpacity={1} activeDot={false} />
        <Tooltip
          cursor={{ stroke: 'white', strokeWidth: 4, strokeDasharray: '14' }}
          content={<CustomTooltip tooltipFormatter={tooltipFormatter} />}
        />
        <Area
          dataKey="total"
          fillOpacity={0}
          strokeOpacity={0}
          activeDot={{ stroke: '#fff', strokeWidth: 5, r: 15, fill: '#1921FA' }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
